/**
 * 道闸信息
 */
import React from "react";
import { Button, Row, Col, Icon, Tooltip } from "antd";
import PageLayout from "../../ui/PageLayout";
import ParkZoneEdit from "./parkZoneEdit";
import { global_data } from '../../ui/auth'


class ParkZoneIndex extends React.Component {
  columns = [
    {
      title: "区域编码",
      dataIndex: "code",
      width: "15%",
    },
    {
      title: "区域名称",
      dataIndex: "name",
      width: "20%",
    },
    {
      title: "类型",
      dataIndex: "type",
      width: "10%",
      format: {
        0: "社会车",
        1: "交易车",
        2: "服务站",
      },
    },
    {
      title: "操作",
      dataIndex: "id",
      width: "10%",
      render: (text, record, index) => (
        <div>
          {global_data.authCode.includes("BARRIER_PARK_ZONE_UPDATE")?
          <Tooltip title="修改">
            <Icon
              type="edit"
              theme="filled"
              title="修改"
              className="table-operate-icon"
              onClick={this.update.bind(this, record)}
            />
          </Tooltip>
          :""}
        </div>
      ),
    },
  ];

  state = {
    visible: false,
    editData: {},
    loadData: "",
  };

  add = () => {
    this.setState({ editData: {} });
    this.showModal();
  };

  showModal = () => {
    this.setState({ visible: true });
  };
  hiddenModal = () => {
    this.setState({ visible: false });
  };

  update = (info, e) => {
    this.setState({ editData: info });
    this.showModal();
  };

  render() {
    return (
      <div style={{ width: "100%", height: "100%" }}>
        <PageLayout
          condition={
            <Row>
              <Col span={24} style={{ textAlign: "right" }}>
                {global_data.authCode.includes("BARRIER_PARK_ZONE_ADD")?
                <Button type="primary" onClick={this.add}>
                  新增
                </Button>
                :""}
              </Col>
            </Row>
          }
          rowKey="code"
          url="/barrier/parkZone/page"
          columns={this.columns}
          loadData={(func) => {
            this.setState({ loadData: func });
          }}
        />
        <ParkZoneEdit
          visible={this.state.visible}
          onCancel={this.hiddenModal.bind(this)}
          editData={this.state.editData}
          successCallback={this.state.loadData}
        />
      </div>
    );
  }
}

export default ParkZoneIndex;
